import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { CreditHoldOrderRow } from '../components/CreditHoldOrderRow';
import { CreditHoldList } from '../../../../modules/ordering/models/credit-hold-list';
import { CreditHoldSearchFilters } from '../../../../modules/ordering/models/credit-hold-search-filters';
import "../../../../modules/ordering/styles.scss";
import { OrderingSvc } from '../../../../modules/ordering/service';
import { CreditHoldFlyout } from '../components/CreditHoldFlyout';
import { CreditHoldDetailFilters } from '../../../../modules/ordering/models/credit-hold-detail-filters';
import { AppUtils } from '../../../../utils/app-utils';
import { CreditHoldReason } from '../../../../support/models/enums/credit-hold-reason';

export const CreditHoldScene = () => {

    const [service] = React.useState(new OrderingSvc());
    const [isFlyoutOpen, setIsFlyoutOpen] = React.useState(false);
    const [flyoutFilter, setFlyoutFilter] = React.useState<CreditHoldDetailFilters>();
    const [selectedDealer, setSelectedDealer] = React.useState('');
    const [selectedReason, setselectedReason] = React.useState<CreditHoldReason|undefined>(undefined);
    const [filterParams, setFilterParams] = React.useState(new CreditHoldSearchFilters());
    const [orders, setOrders] = React.useState(() => {
        const initial = new PagedApiResult<CreditHoldList>();
        initial.pagination = filterParams.paginationInfo;
        initial.pagination.reusePaging = true;
        return initial;
    });

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: CreditHoldSearchFilters) => {
        const response = await service.search(CreditHoldList, filters);
        if (response.status === StatusCode.Success) {
            setOrders(response.data);
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm: any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new CreditHoldSearchFilters();
        setFilterParams(tmp);
    };

    /**
     * Inspect the currently applied filters and create a 
     * detail search object.  Pass that object to the flyout
     * for furter display/processing
     */
    const openFlyout = (dealerId: string, dealerName: string, creditHoldReason: CreditHoldReason) => {

        const filterCopy = {...filterParams} as CreditHoldSearchFilters;

        // Determine the applied filters for the flyout
        const creationDateFilter = AppUtils.getQsValue(filterCopy, 'maxCreationDate');
        const cutoffDateFilter = AppUtils.getQsValue(filterCopy, 'maxCutoff');
        const dayOfWeekFilter = AppUtils.getQsValue(filterCopy, 'matchDayOfWeek');
        const orderIdFilter = AppUtils.getQsValue(filterCopy, 'orderId');

        const detailFilter = new CreditHoldDetailFilters(
            dealerId, 
            creationDateFilter, 
            cutoffDateFilter, 
            dayOfWeekFilter,
            orderIdFilter
        );

        setSelectedDealer(`${dealerName} [${dealerId}]`);       
        setselectedReason(creditHoldReason);
        setFlyoutFilter(detailFilter);
        setIsFlyoutOpen(true);
    };

    /**
     * Close the flyout
     */
    const closeFlyout = () => {
        setIsFlyoutOpen(false);
        onSearch(filterParams);
    };

    return <PageContent pageName={PageNames.ORDERING_CREDIT_HOLD}>
        <PageBody>

            <PagedList
                noResultsMessage="No credit hold orders found, please search again."
                searchCallback={onSearch}
                data={orders}
                filterProps={filterParams}
                selectableClass=""
                onFilterUpdate={onParamsUpdate}
                onReset={onParamsReset}
                hidePager={ true }
                rowRenderer={(order: CreditHoldList) =>
                    <CreditHoldOrderRow 
                        key={ order.dealerId } 
                        order={ order } 
                        onOrderClick={ openFlyout } 
                    />
                }
            />

            <CreditHoldFlyout
                isOpen={isFlyoutOpen}
                onClose={closeFlyout}
                filters={ flyoutFilter }
                dealer={ selectedDealer }
                creditHoldReason = { selectedReason }
            />

        </PageBody>
    </PageContent>;
};
